import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleRoadTaxRecordCategoryEnum } from '../enums/vehicle-road-tax-record-category.enum';
import { VehicleRoadTaxStatusEnum } from '../enums/vehicle-road-tax-status.enum';

import { VehicleRoadTaxLinksDto } from './vehicle-road-tax-links.dto';

/**
 * Vehicle road tax DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_TAX)
export class VehicleRoadTaxSearchDto extends BaseSearchDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadTaxStatusEnum;
  recordCategory!: VehicleRoadTaxRecordCategoryEnum;
  vehicleVin!: string;
  vehicleLicensePlate?: string | null;
  vehicleMakeFull?: string | null;
  totalGross?: number | null;
  links?: VehicleRoadTaxLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
